import type { StaticImageData } from 'next/image';
import {
  A200Presentation,
  AdventureAdrisPresentation,
  AsphaltePresentation,
  BellecourtPresentation,
  ChargerPresentation,
  ChildBikePresentation,
  GalianPresentation,
  NevoPresentation,
  VadrouillePresentation,
  VeloDeVilePresentation,
} from './bike-presentation';

import {
  adventureCharacteristics,
  asphalteCharacteristics,
  chargerCharacteristisc,
  childBikeCharacteristics,
  galianCharacteristics,
  vadrouilleCharacteristics,
  vdvA200Characteristics,
  vdvCharacteristics,
  voltaireCharacteristics,
} from './bike-characteristics';

export type BikePresentationType = {
  title: {
    main: string;
    yellow: string;
    other?: string;
  };
  text: string;
  image: StaticImageData;
};

export enum BikePresentationEnum {
  Nevo = 'riese-muller-nevo-gt',
  Charger = 'riese-muller-charger-gt',
  VeloDeVille = 'velo-tout-chemin-velo-de-ville-a200',
  A200Voyage = 'a200-voyage',
  VeloBellecour = 'velo-voltaire-bellecour-panier',
  Galian = 'velo-cargo-galian',
  GravelVadrouille = 'le-vadrouille',
  AsphalteVadrouille = 'velo-de-route-asphalte',
  AdventureAdris = 'l-aventure',
  ChildBike = 'velo-enfant',
}

export const BikePresentations = {
  [BikePresentationEnum.Nevo]: NevoPresentation,
  [BikePresentationEnum.Charger]: ChargerPresentation,
  [BikePresentationEnum.VeloDeVille]: VeloDeVilePresentation,
  [BikePresentationEnum.A200Voyage]: A200Presentation,
  [BikePresentationEnum.VeloBellecour]: BellecourtPresentation,
  [BikePresentationEnum.Galian]: GalianPresentation,
  [BikePresentationEnum.GravelVadrouille]: VadrouillePresentation,
  [BikePresentationEnum.AsphalteVadrouille]: AsphaltePresentation,
  [BikePresentationEnum.AdventureAdris]: AdventureAdrisPresentation,
  [BikePresentationEnum.ChildBike]: ChildBikePresentation,
};

export type BikeCharacteristicsType = {
  text: string;
  image?: StaticImageData;
  alt?: string;
  className?: string;
};

export const BikeCharacteristics: Record<
  BikePresentationEnum,
  BikeCharacteristicsType[]
> = {
  [BikePresentationEnum.Nevo]: chargerCharacteristisc,
  [BikePresentationEnum.Charger]: chargerCharacteristisc,
  [BikePresentationEnum.VeloDeVille]: vdvCharacteristics,
  [BikePresentationEnum.A200Voyage]: vdvA200Characteristics,
  [BikePresentationEnum.VeloBellecour]: voltaireCharacteristics,
  [BikePresentationEnum.Galian]: galianCharacteristics,
  [BikePresentationEnum.GravelVadrouille]: vadrouilleCharacteristics,
  [BikePresentationEnum.AsphalteVadrouille]: asphalteCharacteristics,
  [BikePresentationEnum.AdventureAdris]: adventureCharacteristics,
  [BikePresentationEnum.ChildBike]: childBikeCharacteristics,
};

export const BikeBrand: Record<BikePresentationEnum, string> = {
  [BikePresentationEnum.Nevo]: 'Riese & Müller',
  [BikePresentationEnum.Charger]: 'Riese & Müller',
  [BikePresentationEnum.VeloDeVille]: 'Vélo de Ville',
  [BikePresentationEnum.A200Voyage]: 'Vélo de Ville',
  [BikePresentationEnum.VeloBellecour]: 'Voltaire',
  [BikePresentationEnum.Galian]: 'Galian',
  [BikePresentationEnum.GravelVadrouille]: 'Adris',
  [BikePresentationEnum.AsphalteVadrouille]: 'Adris',
  [BikePresentationEnum.AdventureAdris]: 'Adris',
  [BikePresentationEnum.ChildBike]: 'RiverSide',
};
